export const checkAuthen = () => {
    const auth = {
        accessToken: !!localStorage.getItem('accessToken'),
        refreshToken: !!localStorage.getItem('refreshToken'),
    };
    // console.log('auth', auth);
    return auth.accessToken && auth.refreshToken;
};
